export default __webpack_public_path__ + "static/media/icon-it-planning-round.a645e27d.svg";